export default __webpack_public_path__ + "static/media/binancewallet.e3ca7553.svg";